module.exports = __webpack_public_path__ + "img/profile-check.d4365c20.svg";